import { createSelector } from '@ngrx/store';

import { paceFeature } from './pace.reducer';

export const { selectPaceState } = paceFeature;

export const selectPaceObject = createSelector(
  selectPaceState,
  (state) => state.object
);

export const selectPaceIsUpdating = createSelector(
  selectPaceObject,
  (pace) => !!pace?.isUpdating
);

export const selectPaceInfoView = createSelector(
  selectPaceState,
  (state) => state.infoView
);

export const selectPaceDetailsDay = createSelector(
  selectPaceState,
  (state) => state.detailsDay
);
